import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import EssLeaveRequestForm from '../components/EssLeaveRequestForm'
import ESSLeaveRequest from '../components/EssLeaveRequest'

function EssLeaveRequestPage() {
  return (
    <EssLayout>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                    <ESSLeaveRequest/>
                </div>

            </div>
        </div>
    </EssLayout>
  )
}

export default EssLeaveRequestPage